import { render, staticRenderFns } from "./superviseReport.vue?vue&type=template&id=20db5898&scoped=true&"
import script from "./superviseReport.vue?vue&type=script&lang=js&"
export * from "./superviseReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20db5898",
  null
  
)

export default component.exports